// React
import React, { useContext } from "react";
// React

// CSS
import styles from "./DeviceItem.module.css";
// CSS

// Models
import { I_DeviceData } from "../../../Models/interfaces";
// Models

// Icons
import { IoLogoAndroid } from "react-icons/io";
import { TfiWorld } from "react-icons/tfi";
import { FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";
import { revokeUserDevice } from "../../../Services/DeviceManager/post/revokeUserDevice";
import { UserTokenContext } from "../../../Contexts/userToken";
import { toast } from "react-toastify";
import { VscWorkspaceUnknown } from "react-icons/vsc";
// Icons

type DeviceItemProps = {
  data: I_DeviceData;
  reloader: () => void;
};

const DeviceItem: React.FunctionComponent<DeviceItemProps> = ({
  data: {
    browser,
    createdDate,
    current,
    currentName,
    deviceTypeId,
    deviceTypeName,
    expiresDate,
    id,
    ip,
    marketName,
    active,
  },
  reloader,
}) => {
  const userToken = useContext(UserTokenContext);
  return (
    <div
      className={`${
        styles.deviceItemContainer
      } p-2  flex flex-row-reverse items-center justify-between ${
        String(active) === "0" ? "opacity-30" : ""
      }`}
    >
      <div
        className={`${styles.imageTypeContainer} flex flex-row items-center justify-center h-full`}
      >
        {String(deviceTypeId) === "1" ? (
          <TfiWorld
            fill="#fff"
            style={{
              background: "#5170fa",
            }}
          />
        ) : null}

        {String(deviceTypeId) === "2" ? (
          <IoLogoAndroid
            fill="#fff"
            style={{
              background: "#8bc24c",
            }}
          />
        ) : null}

        {Boolean(deviceTypeId) === false ? (
          <VscWorkspaceUnknown
            fill="#fff"
            style={{
              background: "#8bc24c",
            }}
          />
        ) : null}
      </div>
      <div
        className={`${styles.deviceContents} flex flex-col items-end w-full`}
      >
        <p className="flex w-full justify-between items-center text-sm font-bold">
          <span>
            {String(active) === "1" ? (
              <FaTrash
                fill="#f44336"
                onClick={() => {
                  Swal.fire({
                    icon: "error",
                    title: "حذف دسترسی",
                    text: "آیا از حذف دسترسی به اکانت خود مطمئن هستید ؟",
                    showCancelButton: true,
                    cancelButtonText: "بیخیال",
                    confirmButtonText: "حذف کن",
                  }).then(({ isConfirmed }) => {
                    if (!isConfirmed) return;
                    toast("درخواست حذف ارسال شد .");
                    revokeUserDevice(userToken, id)
                      .then(({ data }) => {
                        toast(data.message);
                      })
                      .catch((err) => {
                        console.log(err);
                      })
                      .finally(reloader);
                  });
                }}
              />
            ) : null}
          </span>
          <span>{marketName}</span>
        </p>
        <p className="text-sm">{deviceTypeName}</p>
        <p className="flex w-full justify-between items-center text-sm text-gray-600">
          <span className="text-green-400">{current && "Online"}</span>
          <span>{marketName === "DESKTOP" ? `${browser}  ${ip}` : ip}</span>
        </p>
        <p className="text-xs text-gray-600">{createdDate}</p>
        <p className="text-xs text-gray-600">اعتبار تا : {expiresDate}</p>
      </div>
    </div>
  );
};

export default DeviceItem;
